import React from "react";
import PhonemeIntro from "literacy/components/student/phoneme/assign/trainintro";
import PhonemeTrain from "literacy/components/student/phoneme/assign/trainpart";
import PhonemeProgress from "literacy/components/student/phoneme/assign/train-progress";
import PhonemeHeader from "literacy/components/student/phoneme/assets/header";
import { Container } from "@material-ui/core";

class PhonemePractise extends React.Component {
  state = {
    start: false,
    id: "",
    version: "w1"
  };

  render() {
    const { start, id, version } = this.state;
    return (
      <div style={{ backgroundImage: "linear-gradient(to right, #C7D28A, #7CA295)", fontFamily: "raven", height: window.innerHeight, overflowY: "scroll" }}>
        <Container>
          {start ? (
            id === "" ? (
              <PhonemeTrain version={version} />
            ) : (
              <PhonemeProgress id={id} />
            )
          ) : (
              <div>
                <PhonemeHeader part="Training Assignment" backURL="/literacy/student/phoneme"/>
                <PhonemeIntro
                  handleClick={(id, version) => this.setState({ start: !start, id, version })}
                />
              </div>
            )}
        </Container>
      </div>
    );
  }
}
export default PhonemePractise;
